import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data9_4 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        data[0].balance = (numConvert(data[0].year_c) + numConvert(data[0].YTD) - numConvert(data[0].charges)).toFixed(0);

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data9_4);
        let data = JSON.parse(dataBegin);
        fetch(`/_9_6_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_9_6', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_6', 1.5, '9.60', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: '%  百分比',
            dataIndex: 'percent',
            key: 'percent',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">

                        <InputNumber
                            formatter={value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => {
                                let parseValue = value;
                                parseValue = value.replace('%', '').replace(/\$\s?|(,*)/g, '')
                                return parseValue
                            }}
                            className="table_numInput"
                            defaultValue={text == 0 ? "" : (Number(text || "0") * 100).toFixed(3)}
                            precision={1}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/%|,/g, '') || '0');
                                value = (Number(value || "0") / 100).toFixed(3);
                                this.onChange('percent', value, index);
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Beginning of the Year 年初数</div>,
            dataIndex: 'year_c',
            key: 'year_c',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text == 0 ? "" : text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(0));
                                this.onChange('year_c', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>CAPEX & FF&E Reserve Provision YTD <br />年累计 - 固定资产及FF&E计提</div>,
            dataIndex: 'YTD',
            key: 'YTD',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text == 0 ? "" : text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(0));
                                this.onChange('YTD', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>YTD Charges  年累计 - 支出</div>,
            dataIndex: 'charges',
            key: 'charges',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text == 0 ? "" : text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(0));
                                this.onChange('charges', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: 'Closing Balance 当期期末数',
            dataIndex: 'balance',
            align: "center",
            key: 'balance',
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} >
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : (text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )
            }
        }];
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title " id="table9_6">
                        <Row>9.6 Capital Expenditure (CAPEX) and FF&E Reserve 固定资产及FF&E计提 :</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>9.6.1 Comments: (Please list out major CAPEX replacement) 备注：（请列举主要固定资产更换项目）</Row>
                            {!this.state.loading || this.state.print ? <TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                value={this.state.data[0] ? this.state.data[0].note : ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data[0].note = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_6">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-6/index.js